import classnames from "classnames";
import * as React from 'react';
import { ConnectedLink, Link } from 'react-router5';
import { NavigationCategory } from '../../router/NavigationCategory';

export const NavigationCategoryButton: React.FC<Props> = (props) => {

    const [isExpanded, setIsExpanded] = React.useState<boolean>();

    const handleCategoryClick = () => {
        if (props.category.items.length === 1) {
            return;
        }
        setIsExpanded(!isExpanded);
    }
 

    return (
<ul className = {classnames("navigation-category-button__container", {"is-expanded": isExpanded})} onClick = {(e) => e.stopPropagation()}>
    <li className = {classnames("navigation-category-button", {"is-single-button": props.category.items.length === 1})} onClick = {handleCategoryClick}>
        {props.category.items.length === 1
            ?  <ConnectedLink routeName = {props.category.items[0].routeName} activeStrict = {true}>
                    <i className ={props.category.icon} />
                    <div className = "navigation-category-button__label">{props.category.categoryName}</div>
                  </ConnectedLink>
            : <>
            <i className = {"navigation__icon "+ props.category.icon} />
            <div className = "navigation-category-button__label">{props.category.categoryName}</div>
            {isExpanded
                ? <i className ={"fa-chevron-up"} />
                : <i className ={"fa-chevron-down"} />
            }
            </>
        }
    </li>
    {isExpanded &&
    <ul className = "navigation-sub-items">
        {props.category.items.map(i =>
            <li key = {i.routeName}>
                <Link routeName = {i.routeName}>
                    <div className = "navigation__label">
                        {i.displayName}
                    </div>
                </Link>
            </li>
        )}
    </ul>
    }
</ul>
)}

interface Props {
    category: NavigationCategory; 
}